import React, { useState, useEffect } from "react";
import { PromptPageContainer, LeftPromptContainer, RightPromptContainer, InitialPromptWrapper } from './PromptPage.styled';
import PromptCreateView from "../../../../components/PromptCreateView/PromptCreateView";
import PromptConfigView from "../../../../components/PromptConfigView";
import LabelsContainerComponent from "../../../../components/LabelsContainer/LabelsContainer";
import TabsContainerComponent from "../../../../components/TabsContainer";
import { Tabs, Typography } from "@ann/web-components";
import { useStore } from "../../../../../../../hooks";
import { observer } from "mobx-react";
import { ChatComponent } from '../../../../components/ChatComponent';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import { Scrollbar } from '@ann/web-components';
import { ChatProvider } from '../../../../context/ChatContext';
import { LoadingContainer, CustomSpinner } from "../../../../components/PromptCreateView/PromptCreateView.styled";


export const PromptConfigViewsEnum = {
  CREATE: 0,
  CONFIG: 1,
};

const PromptPage = observer(() => {
  const [currentView, setCurrentView] = useState(PromptConfigViewsEnum.CREATE);
  const { editAgent, authStore, historyAgentStore } = useStore();

  useEffect(() => {
    const loadAgents = async () => {
      await editAgent.getAgents(authStore.selectedAccount.id, '');
    };
    
    loadAgents();
  }, [authStore.selectedAccount.id]);

  const selectedAgent = editAgent.agents[0] || null;

  const promptPageInitialContent = (
    <InitialPromptWrapper>
      <ChatBubbleOutlineRoundedIcon color="primary"/>
      <Typography
        category="title"
        size="medium"
        weight="bold"
      >
        Test your Prompt
      </Typography>
      <Typography
        category="body"
        size="large"
        weight="regular"
      >
        Use this simulated chat to see how your prompt responds<br/>
        Send a message to preview its behavior.
      </Typography>
    </InitialPromptWrapper>
  );

  return (
    <ChatProvider>
      <Tabs defaultIndex={currentView} size="medium">
        <LabelsContainerComponent />
        <TabsContainerComponent
          onViewChange={(view) => setCurrentView(view)}
          currentView={currentView}
        />
        <PromptPageContainer>
          <LeftPromptContainer>
            <Scrollbar>
              <Tabs.Panel index={PromptConfigViewsEnum.CREATE}>
                <PromptCreateView />
              </Tabs.Panel>
              <Tabs.Panel index={PromptConfigViewsEnum.CONFIG}>
                <PromptConfigView />
              </Tabs.Panel>
            </Scrollbar>
          </LeftPromptContainer>
          <RightPromptContainer>
            {editAgent.finishedInitialLoad && selectedAgent ? (
              <ChatComponent
                customerSelected={authStore.selectedAccount.id}
                agentId={selectedAgent.id}
                agentData={{
                  id: selectedAgent.id,
                  name: "Test your prompt",
                  avatar: selectedAgent.avatar || null,
                  photo_url: selectedAgent.photo_url || null,
                  placeholderInput: 'Type a test message...'
                }}
                store={editAgent}
                initialContent={promptPageInitialContent}

              />
            ) : (
              <LoadingContainer>
                {!editAgent.finishedInitialLoad ? (
                    <CustomSpinner />
                ) : (
                  <Typography category="title" size="medium" weight="bold">
                    No agent available
                  </Typography>
                )}
              </LoadingContainer>
            )}
          </RightPromptContainer>
        </PromptPageContainer>
      </Tabs>
    </ChatProvider>
  );
});

export default PromptPage;
